function debounce(func, delay) {
  let timeoutId;
  return function () {
    const args = arguments;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

const debouncedMobAccordion = debounce(() => {
  convertMobAccordion();
}, 250);

const debouncedinitAccordionsTabs = debounce(() => {
  initAccordionsTabs();
}, 250);

if (document.readyState !== 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    init();
  });
}

function init() {
  window.addEventListener('resize', debouncedMobAccordion);
  document.addEventListener('render', debouncedinitAccordionsTabs);
  initAccordionsTabs();
}

const keys = {
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  enter: 13,
  space: 32,
};

function keyDownHandler(event, link, list, index) {
  const key = event.keyCode;
  if (!event.shiftKey) {
    switch (key) {
      case keys.down:
        event.preventDefault();
        list[(index + 1) % list.length].focus();
        break;
      case keys.right:
        event.preventDefault();
        list[(index + 1) % list.length].focus();
        break;
      case keys.up:
        event.preventDefault();
        list[(index - 1 + list.length) % list.length].focus();
        break;
      case keys.left:
        event.preventDefault();
        list[(index - 1 + list.length) % list.length].focus();
        break;
      case keys.end:
        event.preventDefault();
        list[list.length - 1].focus();
        break;
      case keys.home:
        event.preventDefault();
        list[0].focus();
        break;
      case keys.enter:
        event.preventDefault();
        moveIndex(link);
        link.click();
        break;
      case keys.space:
        event.preventDefault();
        moveIndex(link);
        link.click();
        break;
      default:
        break;
    }
  }
}

function moveIndex(link) {
  let focusTabs;
  let bs5TabsId = link.closest('.bs5Tabs').id;

  if (link.classList.contains('nav-link')) {
    focusTabs = document.querySelectorAll('#' + bs5TabsId + ' .nav > .nav-item > .nav-link:not([tabindex="-1"])');
  } else {
    focusTabs = document.querySelectorAll(
      '#' + bs5TabsId + ' > .tab-content > .tab-pane > .accordion-button:not([tabindex="-1"])'
    );
  }

  focusTabs.forEach((tab) => {
    tab.setAttribute('tabIndex', '-1');
  });
  link.setAttribute('tabIndex', '0');
}

/**
 * Ensures that the tabPanel (accordion body) is included in the focus cycle (tabindex="0")
 * only if it does not contain any interactive elements. Otherwise, it is excluded (tabindex="-1").
 */
function manageSectionTabIndex() {
  const sections = document.querySelectorAll('.bs5Tabs section, .tab-pane section');
  sections.forEach((section) => {
    const interactiveElements = section.querySelectorAll(
      'a[href], button, input, textarea, select, details, [tabindex="0"]'
    );
    if (interactiveElements.length > 0 || section.querySelectorAll('mhecomm-plp-products-tab').length > 0) {
      section.setAttribute('tabindex', '-1');
    } else {
      section.setAttribute('tabindex', '0');
    }
  });
}
function initAccordionsTabs() {
  const accordionContainers = document.querySelectorAll('.bs5Tabs');
  accordionContainers.forEach((accordionContainer) => {
    const links = accordionContainer.querySelectorAll('.nav>.nav-item>.nav-link');
    links.forEach((link, index) => {
      link.addEventListener('click', () => {
        moveIndex(link);
        const url = new URL(window.location.href);
        url.hash = '#' + link.id;
        history.pushState({}, null, url.href);
      });
      /*
        todo need to refactor this component this piece of code is doing the same thing as navtabs.js 
        will remove this comment after refactoring
      */
      link.addEventListener('keydown', (event) => {
        keyDownHandler(event, link, links, index);
      });
      link.addEventListener('focus', () => {
        link.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    });
    const accordionList = accordionContainer.querySelectorAll('.accordion-button');
    accordionList.forEach((link, index) => {
      link.addEventListener('keydown', (event) => {
        keyDownHandler(event, link, accordionList, index);
      });
    });
  });
  manageSectionTabIndex();
  convertMobAccordion();
}

function convertMobAccordion() {
  const accordionContainers = document.querySelectorAll('.mob-accordion');
  accordionContainers.forEach((accordionContainer) => {
    const isVertical = accordionContainer.classList.contains('vertical');
    const isBorderless =
      accordionContainer.classList.contains('tab-style-secondary') |
      accordionContainer.classList.contains('tab-style-pills');
    const accordions = accordionContainer.querySelectorAll('.tab-pane');
    if (window.innerWidth < 768) {
      if (!isBorderless) {
        accordionContainer.classList.remove(isVertical ? 'border-start' : 'border-top');
      }
      accordions.forEach((accordion) => {
        accordion.classList.add('accordion-item');
        accordion.classList.add('d-block');
        accordion.classList.add('opacity-100');
        const collapse = accordion.querySelector('.accordion-collapse');
        if (collapse) {
          collapse.classList.remove('d-block');
        }
      });
    } else {
      if (!isBorderless) {
        accordionContainer.classList.add(isVertical ? 'border-start' : 'border-top');
      }
      accordions.forEach((accordion) => {
        accordion.classList.remove('accordion-item');
        accordion.classList.remove('d-block');
        accordion.classList.remove('opacity-100');
        const collapse = accordion.querySelector('.accordion-collapse');
        if (collapse) {
          collapse.classList.add('d-block');
        }
      });
    }
  });
}
